import type { UserRole } from '@emazy/shared-types';

export function mapCognitoGroups(groups: unknown): UserRole[] {
  const values = Array.isArray(groups)
    ? groups.filter((group): group is string => typeof group === 'string')
    : [];
  const roles: UserRole[] = ['customer'];
  if (values.includes('workshop')) roles.push('workshop');
  if (values.includes('admin')) roles.push('admin');
  return roles;
}
